import { render, staticRenderFns } from "./timeProperty.vue?vue&type=template&id=803f7210"
import script from "./timeProperty.vue?vue&type=script&lang=js"
export * from "./timeProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports